import GraphicFormatedData from 'src/models/Chart/GraphicFormatedData';

const isEmptyGraphicsData = (
  graphicFormatedData: GraphicFormatedData[],
): boolean => graphicFormatedData.every(({ value }) => value === 0);

export default isEmptyGraphicsData;
